<!-- ═══════════════ MODAL HEADER ═══════════════ -->
<div class="modal-header">
  <h3 class="modal-title">
    <strong>Source Details</strong>
    @if (isScenarioLocked) {
<i class="fa fa-lock" style="margin-left: 8px; color: #d9534f;"></i>
}
  </h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Lock warning banner -->
@if (isScenarioLocked && !minimise) {
<div class="lock-banner">
  <i class="fa fa-lock"></i>
  This scenario is locked. Editing is disabled.
</div>
}

<!-- ═══════════════ MODAL BODY ═══════════════ -->
<form class="form-horizontal" [hidden]="minimise" novalidate>
<div class="modal-body no-body-scroll">
  <div class="divShadow1">

    <!-- ─── Header Entity Table ─── -->
    <div class="entity-table-wrap">
      <table class="entity-info-table">
        <thead>
          <tr>
            <th>LEID</th>
            <th>Tax Code</th>
            <th>Reporting Period</th>
            <th>ME Code</th>
            <th>Gross Inc/Exp</th>
            <th>Trans Category</th>
            @if (scenarioDesc === 'EXAM') {
<th>Issue Id</th>
}
            @if (hasColumn('Basket')) {
<th>Basket</th>
}
            @if (hasColumn('SIC Code')) {
<th>SIC Code</th>
}
            @if (hasColumn('FDII')) {
<th>FDII</th>
}
            @if (hasColumn('Applicable Year')) {
<th>WH Applicable Year</th>
}
            @if (hasColumn('Beat')) {
<th>BEAT</th>
}
            @if (hasColumn('Beat Type')) {
<th>BEAT Type</th>
}
            @if (hasColumn('Beat Withhold')) {
<th>BEAT Withhold (%)</th>
}
            @if (hasColumn('Related/Unrelated')) {
<th>Related/Unrelated</th>
}
            @if (hasColumn('Trading Partner')) {
<th>Trading Partner</th>
}
            @if (hasColumn('Country')) {
<th>Country</th>
}
            @if (hasColumn('HTKO')) {
<th>HTKO</th>
}
            @if (hasColumn('FSE')) {
<th>FSE</th>
}
            @if (hasColumn('Source Type')) {
<th>Source Type</th>
}
            @if (hasColumn('Project Tagging')) {
<th>Project Tagging</th>
}
            @if (hasColumn('Notes')) {
<th>Notes</th>
}
            @if (hasColumn('Method')) {
<th>Method</th>
}
            @if (hasColumn('Base FDII')) {
<th>Base FDII</th>
}
            @if (hasColumn('Base Basket')) {
<th>Base Basket</th>
}
            @if (hasColumn('Base Type')) {
<th>Base Type</th>
}
            @if (hasColumn('Base Level')) {
<th>Base Level</th>
}
            @if (hasColumn('Base Entity Level')) {
<th>Base Entity Level</th>
}
          </tr>
        </thead>
        <tbody>
          @for (t of selectedRows; track $index) {
<tr>
            <td>{{ t.LEID }}</td>
            <td>{{ t.CDR_NO }}</td>
            <td>{{ t.REPORTING_PERIOD }}</td>
            <td>{{ t.ME_CODE }}</td>
            <td>{{ t.GIE_SHORT_DESC }}</td>
            <td>{{ t.TRANS_CATG_NAME }}</td>
            @if (scenarioDesc === 'EXAM') {
<td>{{ t.ISSUE_KEY }}</td>
}
            @if (hasColumn('Basket')) {
<td>{{ t.BASKET_0 }}</td>
}
            @if (hasColumn('SIC Code')) {
<td>{{ t.SIC_CODES_0 }}</td>
}
            @if (hasColumn('FDII')) {
<td>{{ t.FDII_0 }}</td>
}
            @if (hasColumn('Applicable Year')) {
<td>{{ t.APPLICABLE_YEAR_0 }}</td>
}
            @if (hasColumn('Beat')) {
<td>{{ t.BEAT_0 }}</td>
}
            @if (hasColumn('Beat Type')) {
<td>{{ t.BEAT_TYPE_0 }}</td>
}
            @if (hasColumn('Beat Withhold')) {
<td>{{ t.BEAT_WITHHOLD_0 }}</td>
}
            @if (hasColumn('Related/Unrelated')) {
<td>{{ t.RELATED_UNRELATED_0 }}</td>
}
            @if (hasColumn('Trading Partner')) {
<td>{{ t.ACTUAL_TP_KEY_LENAME_0 }}</td>
}
            @if (hasColumn('Country')) {
<td>{{ t.COUNTRY_0 }}</td>
}
            @if (hasColumn('HTKO')) {
<td>{{ t.HTKO_0 }}</td>
}
            @if (hasColumn('FSE')) {
<td>{{ t.FSE_0 }}</td>
}
            @if (hasColumn('Source Type')) {
<td>{{ t.SOURCE_TYPE_0 }}</td>
}
            @if (hasColumn('Project Tagging')) {
<td>{{ t.PROJECT_TAGGING_0 }}</td>
}
            @if (hasColumn('Notes')) {
<td>{{ t.NOTES_0 }}</td>
}
            @if (hasColumn('Method')) {
<td>{{ t.METHOD_0 }}</td>
}
            @if (hasColumn('Base FDII')) {
<td>{{ t.BASE_FDII_0 }}</td>
}
            @if (hasColumn('Base Basket')) {
<td>{{ t.BASE_BASKET_0 }}</td>
}
            @if (hasColumn('Base Type')) {
<td>{{ t.BASE_TYPE_0 }}</td>
}
            @if (hasColumn('Base Level')) {
<td>{{ t.BASE_LEVEL_0 }}</td>
}
            @if (hasColumn('Base Entity Level')) {
<td>{{ t.BASE_ENTITY_LEVEL_0 }}</td>
}
          </tr>
}
        </tbody>
      </table>
    </div>

    <!-- ═══════════════ NON-EXAM SOURCING TAG SECTION ═══════════════ -->
    @if (scenarioDesc !== 'EXAM') {


      <!-- ─── Source By + More Options Row (Amount / Summary, no WH) ─── -->
      @if (selectedSourceTypeDesc !== 'Percentage' && !loadingData_changeSource && !enableMoreOptions) {
<div class="row controls-row"
          >
        <div class="col-md-5">
          <label style="width: 40%;">Source By
            <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="sourceByDataView"
  [selectType]="'single'" [title]="'Source By'" [hideTitleOnInput]="true" [inputAriaLabel]="'Source By'"
  [disabled]="defaultTag"
  [(ngModel)]="selectedSourceTypeItem"
  name="sourceBy"
  (onSelect)="onChangeSourceByFromDropdown($event)">
  @for (item of sourceByDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Source By')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
          </label>
        </div>
        @if (moreOptionsData.length > 0) {
<div class="col-md-7">
          <label style="float: right; width: 34%;">More Options
            <ap-dropdown style="width:100%" [selectType]="'multiple'" [enableNgContent]="false"
                           [list]="dropdownLists['moreOptions']" [optionName]="'GIE_SHORT_DESC'" [optionValue]="'GIE_KEY'"
                           [title]="'Select'" [inputAriaLabel]="'More options'" [hideTitleOnInput]="true"
                           [showSearchbox]="true" [showSelectAll]="true" [clearSearchKeyword]="true"
                           (onFilterResult)="onDropdownFilterResult('moreOptions', $event)"
                           [(ngModel)]="selectedGieTypes" name="moreOpts"
                           (onSelect)="getMoreAccounts()"
                           [disabled]="defaultTag || selectedSourceTypeDesc === 'Summary' || assestSourcing">
            </ap-dropdown>
          </label>
        </div>
}
      </div>
}

      <!-- ─── Source By + More Options Row (Amount / Summary, WH enabled) ─── -->
      @if (selectedSourceTypeDesc !== 'Percentage' && !loadingData_changeSource && enableMoreOptions) {
<div class="row controls-row"
          >
        <div class="col-md-5">
          <label style="width: 40%;">Source By
            <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="sourceByDataView"
  [selectType]="'single'" [title]="'Source By'" [hideTitleOnInput]="true" [inputAriaLabel]="'Source By'"
  [disabled]="defaultTag"
  [(ngModel)]="selectedSourceTypeItem"
  name="sourceByWH"
  (onSelect)="onChangeSourceByFromDropdown($event)">
  @for (item of sourceByDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Source By')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
          </label>
        </div>
        @if (moreOptionsDataWH.length > 0) {
<div class="col-md-7">
          <label style="float: right; width: 34%;">More Options
            <ap-dropdown style="width:100%" [selectType]="'multiple'" [enableNgContent]="false"
                           [list]="dropdownLists['moreOptionsWH']" [optionName]="'GIE_SHORT_DESC'" [optionValue]="'GIE_KEY'"
                           [title]="'Select'" [inputAriaLabel]="'More options'" [hideTitleOnInput]="true"
                           [showSearchbox]="true" [showSelectAll]="true" [clearSearchKeyword]="true"
                           (onFilterResult)="onDropdownFilterResult('moreOptionsWH', $event)"
                           [(ngModel)]="selectedGieTypes" name="moreOptsWH"
                           (onSelect)="getMoreAccounts()">
            </ap-dropdown>
          </label>
        </div>
}
      </div>
}

      <!-- ─── Source By + Apply Percentage + More Options (Percentage mode) ─── -->
      @if (selectedSourceTypeDesc === 'Percentage' && !loadingData_changeSource) {
<div class="row controls-row"
          >
        <div class="col-md-5">
          <label style="width: 40%;">Source By
            <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="sourceByDataView"
  [selectType]="'single'" [title]="'Source By'" [hideTitleOnInput]="true" [inputAriaLabel]="'Source By'"
  [disabled]="defaultTag"
  [(ngModel)]="selectedSourceTypeItem"
  name="sourceByPct"
  (onSelect)="onChangeSourceByFromDropdown($event)">
  @for (item of sourceByDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Source By')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
          </label>
          <button class="btn btn-info btn-sm" type="button" style="margin-left: 20px;"
                  (click)="openPopUpWindow()">Apply Percentage</button>
        </div>
        @if (moreOptionsData.length > 0) {
<div class="col-md-7">
          <label style="float: right; width: 34%;">More Options
            <ap-dropdown style="width:100%" [selectType]="'multiple'" [enableNgContent]="false"
                           [list]="dropdownLists['moreOptions']" [optionName]="'GIE_SHORT_DESC'" [optionValue]="'GIE_KEY'"
                           [title]="'Select'" [inputAriaLabel]="'More options'" [hideTitleOnInput]="true"
                           [showSearchbox]="true" [showSelectAll]="true" [clearSearchKeyword]="true"
                           (onFilterResult)="onDropdownFilterResult('moreOptions', $event)"
                           [(ngModel)]="selectedGieTypes" name="moreOptsPct"
                           (onSelect)="getMoreAccounts()"
                           [disabled]="defaultTag || assestSourcing">
            </ap-dropdown>
          </label>
        </div>
}
      </div>
}

      <!-- ─── Loaders ─── -->
      @if (loadingData_changeSource) {
<div class="formLoader"><i class="fa fa-spinner fa-spin"></i></div>
}
      @if (loadingData) {
<div class="formLoader"><i class="fa fa-spinner fa-spin"></i></div>
}

      <!-- ════════ DATA TABLES ════════ -->
      @if (!loadingData && !loadingData_changeSource) {
<div class="sourcing-table-wrap">
        @if (loadingData_new) {
<div class="formLoader"><i class="fa fa-spinner fa-spin"></i></div>
}

        <!-- ──── AMOUNT (non-asset) ──── -->
        @if (selectedSourceTypeDesc === 'Amount' && !assestSourcing) {
<div class="sourcing-table-body-scroll">
          <table class="sourcing-data-table sourcing-data-table--wide">
            <thead>
              <tr>
                <th colspan="3" class="group-header border-right">Accounts</th>
                <th colspan="4" class="group-header border-right">Book</th>
                <th colspan="4" class="group-header border-right">Sch M</th>
                <th colspan="2" class="group-header">Acct Desc</th>
              </tr>
              <tr>
                <th style="width:6%">Gross Inc/Exp</th>
                <th style="width:7%">System Account</th>
                <th style="width:7%" class="border-right">General Ledger</th>
                <th style="width:10%">Total</th>
                <th style="width:10%">Sourced Amount</th>
                <th style="width:10%">Amount to Source</th>
                <th style="width:10%" class="border-right">Remainder</th>
                <th style="width:10%">Total</th>
                <th style="width:10%">Sourced Amount</th>
                <th style="width:10%">Amount to Source</th>
                <th style="width:10%" class="border-right">Remainder</th>
                <th>Acct Desc</th>
              </tr>
            </thead>
            <tbody>
              @for (t of accountSourcingData; track $index) {
<tr>
                <td>{{ t.ALT_GIE_NAME }}</td>
                <td>{{ t.SYS_ACCT }}</td>
                <td class="border-right" [title]="t.ACCT_DESC">{{ t.ACCT }}</td>
                <td [class.color-red]="t.BOOK_TOTAL_AMT < 0">{{ formatNumber(t.BOOK_TOTAL_AMT) }}</td>
                <td [class.color-red]="t.BOOK_SOURCE_AMT < 0">{{ formatNumber(t.BOOK_SOURCE_AMT) }}</td>
                <td [class.color-red]="t.BOOK_AMOUNT_TO_SOURCE < 0">
                  @if (defaultTag || t.ACCT === 'Total' || t.ALT_GIE_NAME === t.SYS_ACCT) {
<span>{{ formatNumber(t.BOOK_AMOUNT_TO_SOURCE) }}</span>
}
                  @if (!defaultTag && t.ACCT !== 'Total' && t.ALT_GIE_NAME !== t.SYS_ACCT) {
<input
                         type="number" [(ngModel)]="t.BOOK_AMOUNT_TO_SOURCE" [ngModelOptions]="{standalone: true}"
                         (ngModelChange)="updateRemainder(t, 'book')">
}
                </td>
                <td [class.color-red]="t.BOOK_REMAINDER < 0" class="border-right">{{ formatNumber(t.BOOK_REMAINDER) }}</td>
                <td [class.color-red]="t.SCHDM_TOTAL_AMT < 0">{{ formatNumber(t.SCHDM_TOTAL_AMT) }}</td>
                <td [class.color-red]="t.SCHDM_SOURCE_AMT < 0">{{ formatNumber(t.SCHDM_SOURCE_AMT) }}</td>
                <td [class.color-red]="t.SCHDM_AMOUNT_TO_SOURCE < 0">
                  @if (defaultTag || t.ACCT === 'Total' || t.ALT_GIE_NAME === t.SYS_ACCT) {
<span>{{ formatNumber(t.SCHDM_AMOUNT_TO_SOURCE) }}</span>
}
                  @if (!defaultTag && t.ACCT !== 'Total' && t.ALT_GIE_NAME !== t.SYS_ACCT) {
<input
                         type="number" [(ngModel)]="t.SCHDM_AMOUNT_TO_SOURCE" [ngModelOptions]="{standalone: true}"
                         (ngModelChange)="updateRemainder(t, 'schM')">
}
                </td>
                <td [class.color-red]="t.SCHDM_REMAINDER < 0" class="border-right">{{ formatNumber(t.SCHDM_REMAINDER) }}</td>
                <td class="nowrap">{{ t.ACCT_DESC }}</td>
              </tr>
}
              <!-- More Options rows -->
              @for (t of moreAccountsToShow; track $index) {
<tr>
                <td>{{ t.ALT_GIE_NAME }}</td>
                <td>{{ t.SYS_ACCT }}</td>
                <td class="border-right" [title]="t.ACCT_DESC">{{ t.ACCT }}</td>
                <td [class.color-red]="t.BOOK_TOTAL_AMT < 0">{{ formatNumber(t.BOOK_TOTAL_AMT) }}</td>
                <td [class.color-red]="t.BOOK_SOURCE_AMT < 0">{{ formatNumber(t.BOOK_SOURCE_AMT) }}</td>
                <td [class.color-red]="t.BOOK_AMOUNT_TO_SOURCE < 0">
                  @if ((defaultTag && !enableSaveButton) || t.ACCT === 'Total' || (t.ALT_GIE_NAME === t.SYS_ACCT && t.ALT_GIE_NAME !== 'WHTAXES')) {
<span>{{ formatNumber(t.BOOK_AMOUNT_TO_SOURCE) }}</span>
}
                  @if ((!defaultTag && t.ACCT !== 'Total' && (t.ALT_GIE_NAME !== t.SYS_ACCT || t.ALT_GIE_NAME === 'WHTAXES')) || enableSaveButton) {
<input
                         type="number" [(ngModel)]="t.BOOK_AMOUNT_TO_SOURCE" [ngModelOptions]="{standalone: true}"
                         (ngModelChange)="updateRemainder(t, 'book')">
}
                </td>
                <td [class.color-red]="t.BOOK_REMAINDER < 0" class="border-right">{{ formatNumber(t.BOOK_REMAINDER) }}</td>
                <td [class.color-red]="t.SCHDM_TOTAL_AMT < 0">{{ formatNumber(t.SCHDM_TOTAL_AMT) }}</td>
                <td [class.color-red]="t.SCHDM_SOURCE_AMT < 0">{{ formatNumber(t.SCHDM_SOURCE_AMT) }}</td>
                <td [class.color-red]="t.SCHDM_AMOUNT_TO_SOURCE < 0">
                  @if (defaultTag || t.ALT_GIE_NAME === 'WHTAXES' || t.ACCT === 'Total' || t.ALT_GIE_NAME === t.SYS_ACCT) {
<span>{{ formatNumber(t.SCHDM_AMOUNT_TO_SOURCE) }}</span>
}
                  @if (!defaultTag && t.ALT_GIE_NAME !== 'WHTAXES' && t.ACCT !== 'Total' && t.ALT_GIE_NAME !== t.SYS_ACCT) {
<input
                         type="number" [(ngModel)]="t.SCHDM_AMOUNT_TO_SOURCE" [ngModelOptions]="{standalone: true}"
                         (ngModelChange)="updateRemainder(t, 'schM')">
}
                </td>
                <td [class.color-red]="t.SCHDM_REMAINDER < 0" class="border-right">{{ formatNumber(t.SCHDM_REMAINDER) }}</td>
                <td class="nowrap">{{ t.ACCT_DESC }}</td>
              </tr>
}
              <!-- Total row -->
              @if (TotalData.length > 0) {
<tr class="total-row">
                <td></td><td></td>
                <td class="border-right bold">{{ TotalData[0].ACCT }}</td>
                <td [class.color-red]="TotalData[0].BOOK_TOTAL_AMT < 0">{{ formatNumber(TotalData[0].BOOK_TOTAL_AMT) }}</td>
                <td [class.color-red]="TotalData[0].BOOK_SOURCE_AMT < 0">{{ formatNumber(TotalData[0].BOOK_SOURCE_AMT) }}</td>
                <td [class.color-red]="TotalData[0].BOOK_AMOUNT_TO_SOURCE < 0">{{ formatNumber(TotalData[0].BOOK_AMOUNT_TO_SOURCE) }}</td>
                <td [class.color-red]="TotalData[0].BOOK_REMAINDER < 0" class="border-right">{{ formatNumber(TotalData[0].BOOK_REMAINDER) }}</td>
                <td [class.color-red]="TotalData[0].SCHDM_TOTAL_AMT < 0">{{ formatNumber(TotalData[0].SCHDM_TOTAL_AMT) }}</td>
                <td [class.color-red]="TotalData[0].SCHDM_SOURCE_AMT < 0">{{ formatNumber(TotalData[0].SCHDM_SOURCE_AMT) }}</td>
                <td [class.color-red]="TotalData[0].SCHDM_AMOUNT_TO_SOURCE < 0">{{ formatNumber(TotalData[0].SCHDM_AMOUNT_TO_SOURCE) }}</td>
                <td [class.color-red]="TotalData[0].SCHDM_REMAINDER < 0" class="border-right">{{ formatNumber(TotalData[0].SCHDM_REMAINDER) }}</td>
                <td></td>
              </tr>
}
            </tbody>
          </table>
        </div>
}

        <!-- ──── PERCENTAGE (non-asset) ──── -->
        @if (selectedSourceTypeDesc === 'Percentage' && !assestSourcing) {
<div class="sourcing-table-body-scroll">
          <table class="sourcing-data-table sourcing-data-table--wide">
            <thead>
              <tr>
                <th colspan="4" class="group-header border-right">Accounts</th>
                <th colspan="6" class="group-header border-right">Book</th>
                <th colspan="6" class="group-header border-right">Sch M</th>
                <th colspan="1" class="group-header">Acct</th>
              </tr>
              <tr>
                @if (!defaultTag) {
<th style="width:2%"><input type="checkbox" [(ngModel)]="checkAllButton" [ngModelOptions]="{standalone: true}" (change)="checkAll()"></th>
}
                <th style="width:5%">Gross Inc/Exp</th>
                <th style="width:5%">System Account</th>
                <th style="width:5%" class="border-right">General Ledger</th>
                <th style="width:5%">Total</th><th style="width:5%">Sourced Amount</th>
                <th style="width:5%">Existing Amount to Source</th><th style="width:5%">% to Source</th>
                <th style="width:5%">New Amount to Source</th><th style="width:5%" class="border-right">Remainder</th>
                <th style="width:5%">Total</th><th style="width:5%">Sourced Amount</th>
                <th style="width:5%">Existing Amount to Source</th><th style="width:5%">% to Source</th>
                <th style="width:5%">New Amount to Source</th><th style="width:5%" class="border-right">Remainder</th>
                <th>Acct Desc</th>
              </tr>
            </thead>
            <tbody>
              @for (t of accountSourcingData; track $index) {
<tr>
                @if (!defaultTag) {
<td>@if (t.ACCT !== 'Total' && t.ALT_GIE_NAME !== t.SYS_ACCT) {
<input type="checkbox" [(ngModel)]="t.SOURCED_CHECKBOX" [ngModelOptions]="{standalone: true}">
}</td>
}
                <td>{{ t.ALT_GIE_NAME }}</td><td>{{ t.SYS_ACCT }}</td>
                <td class="border-right" [title]="t.ACCT_DESC">{{ t.ACCT }}</td>
                <td [class.color-red]="t.BOOK_TOTAL_AMT < 0">{{ formatNumber(t.BOOK_TOTAL_AMT) }}</td>
                <td [class.color-red]="t.BOOK_SOURCE_AMT < 0">{{ formatNumber(t.BOOK_SOURCE_AMT) }}</td>
                <td [class.color-red]="t.BOOK_AMOUNT_TO_SOURCE < 0">{{ formatNumber(t.BOOK_AMOUNT_TO_SOURCE) }}</td>
                <td>
                  @if (defaultTag || t.ACCT === 'Total' || t.ALT_GIE_NAME === t.SYS_ACCT) {
<span>{{ t.BOOK_PERCENT }}</span>
}
                  @if (!defaultTag && t.ACCT !== 'Total' && t.ALT_GIE_NAME !== t.SYS_ACCT) {
<input
                         type="text" style="width:50px" [(ngModel)]="t.BOOK_PERCENT" [ngModelOptions]="{standalone: true}"
                         (ngModelChange)="updatePercentRemainder(t, 'book')">
}
                </td>
                <td [class.color-red]="t.NEW_BOOK_AMOUNT_TO_SOURCE < 0">{{ formatNumber(t.NEW_BOOK_AMOUNT_TO_SOURCE) }}</td>
                <td [class.color-red]="t.BOOK_REMAINDER < 0" class="border-right">{{ formatNumber(t.BOOK_REMAINDER) }}</td>
                <td [class.color-red]="t.SCHDM_TOTAL_AMT < 0">{{ formatNumber(t.SCHDM_TOTAL_AMT) }}</td>
                <td [class.color-red]="t.SCHDM_SOURCE_AMT < 0">{{ formatNumber(t.SCHDM_SOURCE_AMT) }}</td>
                <td [class.color-red]="t.SCHDM_AMOUNT_TO_SOURCE < 0">{{ formatNumber(t.SCHDM_AMOUNT_TO_SOURCE) }}</td>
                <td>
                  @if (defaultTag || t.ACCT === 'Total' || t.ALT_GIE_NAME === t.SYS_ACCT) {
<span>{{ t.SCHDM_PERCENT }}</span>
}
                  @if (!defaultTag && t.ACCT !== 'Total' && t.ALT_GIE_NAME !== t.SYS_ACCT) {
<input
                         type="text" style="width:50px" [(ngModel)]="t.SCHDM_PERCENT" [ngModelOptions]="{standalone: true}"
                         (ngModelChange)="updatePercentRemainder(t, 'SchM')">
}
                </td>
                <td [class.color-red]="t.NEW_SCHDM_AMOUNT_TO_SOURCE < 0">{{ formatNumber(t.NEW_SCHDM_AMOUNT_TO_SOURCE) }}</td>
                <td [class.color-red]="t.SCHDM_REMAINDER < 0" class="border-right">{{ formatNumber(t.SCHDM_REMAINDER) }}</td>
                <td class="nowrap">{{ t.ACCT_DESC }}</td>
              </tr>
}
              @for (t of moreAccountsToShow; track $index) {
<tr>
                @if (!defaultTag) {
<td>@if (t.ACCT !== 'Total' && t.ALT_GIE_NAME !== t.SYS_ACCT) {
<input type="checkbox" [(ngModel)]="t.SOURCED_CHECKBOX" [ngModelOptions]="{standalone: true}">
}</td>
}
                <td>{{ t.ALT_GIE_NAME }}</td><td>{{ t.SYS_ACCT }}</td>
                <td class="border-right" [title]="t.ACCT_DESC">{{ t.ACCT }}</td>
                <td [class.color-red]="t.BOOK_TOTAL_AMT < 0">{{ formatNumber(t.BOOK_TOTAL_AMT) }}</td>
                <td [class.color-red]="t.BOOK_SOURCE_AMT < 0">{{ formatNumber(t.BOOK_SOURCE_AMT) }}</td>
                <td [class.color-red]="t.BOOK_AMOUNT_TO_SOURCE < 0">{{ formatNumber(t.BOOK_AMOUNT_TO_SOURCE) }}</td>
                <td>
                  @if (defaultTag || t.ACCT === 'Total' || t.ALT_GIE_NAME === t.SYS_ACCT) {
<span>{{ t.BOOK_PERCENT }}</span>
}
                  @if (!defaultTag && t.ACCT !== 'Total' && t.ALT_GIE_NAME !== t.SYS_ACCT) {
<input
                         type="text" style="width:50px" [(ngModel)]="t.BOOK_PERCENT" [ngModelOptions]="{standalone: true}"
                         (ngModelChange)="updatePercentRemainder(t, 'book')">
}
                </td>
                <td [class.color-red]="t.NEW_BOOK_AMOUNT_TO_SOURCE < 0">{{ formatNumber(t.NEW_BOOK_AMOUNT_TO_SOURCE) }}</td>
                <td [class.color-red]="t.BOOK_REMAINDER < 0" class="border-right">{{ formatNumber(t.BOOK_REMAINDER) }}</td>
                <td [class.color-red]="t.SCHDM_TOTAL_AMT < 0">{{ formatNumber(t.SCHDM_TOTAL_AMT) }}</td>
                <td [class.color-red]="t.SCHDM_SOURCE_AMT < 0">{{ formatNumber(t.SCHDM_SOURCE_AMT) }}</td>
                <td [class.color-red]="t.SCHDM_AMOUNT_TO_SOURCE < 0">{{ formatNumber(t.SCHDM_AMOUNT_TO_SOURCE) }}</td>
                <td>
                  @if (defaultTag || t.ALT_GIE_NAME === 'WHTAXES' || t.ACCT === 'Total' || t.ALT_GIE_NAME === t.SYS_ACCT) {
<span>{{ t.SCHDM_PERCENT }}</span>
}
                  @if (!defaultTag && t.ALT_GIE_NAME !== 'WHTAXES' && t.ACCT !== 'Total' && t.ALT_GIE_NAME !== t.SYS_ACCT) {
<input
                         type="text" style="width:50px" [(ngModel)]="t.SCHDM_PERCENT" [ngModelOptions]="{standalone: true}"
                         (ngModelChange)="updatePercentRemainder(t, 'SchM')">
}
                </td>
                <td [class.color-red]="t.NEW_SCHDM_AMOUNT_TO_SOURCE < 0">{{ formatNumber(t.NEW_SCHDM_AMOUNT_TO_SOURCE) }}</td>
                <td [class.color-red]="t.SCHDM_REMAINDER < 0" class="border-right">{{ formatNumber(t.SCHDM_REMAINDER) }}</td>
                <td class="nowrap">{{ t.ACCT_DESC }}</td>
              </tr>
}
            </tbody>
          </table>
        </div>
}

        <!-- ──── SUMMARY (non-asset) ──── -->
        @if (selectedSourceTypeDesc === 'Summary' && !assestSourcing) {
<div class="sourcing-table-body-scroll">
          <table class="sourcing-data-table">
            <thead>
              <tr>
                <th [attr.colspan]="enableSaveButton ? 3 : 1" class="group-header border-right">Accounts</th>
                <th colspan="4" class="group-header border-right">Book</th>
                <th colspan="4" class="group-header border-right">Sch M</th>
              </tr>
              <tr>
                <th style="width:5%" [class.border-right]="!enableSaveButton">Gross Inc/Exp</th>
                @if (enableSaveButton) {
<th style="width:5%">System Account</th>
}
                @if (enableSaveButton) {
<th style="width:5%" class="border-right">General Ledger</th>
}
                <th style="width:5%">Total</th><th style="width:5%">Sourced Amount</th>
                <th style="width:5%">Amount to Source</th><th style="width:5%" class="border-right">Remainder</th>
                <th style="width:5%">Total</th><th style="width:5%">Sourced Amount</th>
                <th style="width:5%">Amount to Source</th><th style="width:5%">Remainder</th>
              </tr>
            </thead>
            <tbody>
              @for (t of accountSourcingData; track $index) {
<tr>
                <td [class.border-right]="!enableSaveButton">{{ t.ALT_GIE_NAME }}</td>
                @if (enableSaveButton) {
<td></td>
}
                @if (enableSaveButton) {
<td class="border-right"></td>
}
                <td [class.color-red]="t.BOOK_TOTAL_AMT < 0">{{ formatNumber(t.BOOK_TOTAL_AMT) }}</td>
                <td [class.color-red]="t.BOOK_SOURCE_AMT < 0">{{ formatNumber(t.BOOK_SOURCE_AMT) }}</td>
                <td [class.color-red]="t.BOOK_AMOUNT_TO_SOURCE < 0">
                  @if (defaultTag) {
<span>{{ formatNumber(t.BOOK_AMOUNT_TO_SOURCE) }}</span>
}
                  @if (!defaultTag) {
<input type="number" [(ngModel)]="t.BOOK_AMOUNT_TO_SOURCE" [ngModelOptions]="{standalone: true}"
                         (ngModelChange)="updateRemainder(t, 'book')">
}
                </td>
                <td [class.color-red]="t.BOOK_REMAINDER < 0" class="border-right">{{ formatNumber(t.BOOK_REMAINDER) }}</td>
                <td [class.color-red]="t.SCHDM_TOTAL_AMT < 0">{{ formatNumber(t.SCHDM_TOTAL_AMT) }}</td>
                <td [class.color-red]="t.SCHDM_SOURCE_AMT < 0">{{ formatNumber(t.SCHDM_SOURCE_AMT) }}</td>
                <td [class.color-red]="t.SCHDM_AMOUNT_TO_SOURCE < 0">
                  @if (defaultTag) {
<span>{{ formatNumber(t.SCHDM_AMOUNT_TO_SOURCE) }}</span>
}
                  @if (!defaultTag) {
<input type="number" [(ngModel)]="t.SCHDM_AMOUNT_TO_SOURCE" [ngModelOptions]="{standalone: true}"
                         (ngModelChange)="updateRemainder(t, 'schM')">
}
                </td>
                <td [class.color-red]="t.SCHDM_REMAINDER < 0">{{ formatNumber(t.SCHDM_REMAINDER) }}</td>
              </tr>
}
            </tbody>
          </table>
        </div>
}

        <!-- ──── AMOUNT (asset) ──── -->
        @if (selectedSourceTypeDesc === 'Amount' && assestSourcing) {
<div class="sourcing-table-body-scroll">
          <table class="sourcing-data-table">
            <thead>
              <tr>
                <th colspan="2" class="group-header border-right">Accounts</th>
                <th colspan="4" class="group-header border-right">Tax</th>
                <th colspan="1" class="group-header">Acct Desc</th>
              </tr>
              <tr>
                <th style="width:10%">Gross Inc/Exp</th>
                <th style="width:10%" class="border-right">System Account</th>
                <th style="width:15%">Total</th><th style="width:15%">Sourced Amount</th>
                <th style="width:15%">Amount to Source</th><th style="width:15%" class="border-right">Remainder</th>
                <th style="width:10%">Acct Desc</th>
              </tr>
            </thead>
            <tbody>
              @for (t of accountSourcingData; track $index) {
<tr>
                <td>{{ t.ALT_GIE_NAME }}</td>
                <td class="border-right">{{ t.SYS_ACCT }}</td>
                <td [class.color-red]="t.BOOK_TOTAL_AMT < 0">{{ formatNumber(t.BOOK_TOTAL_AMT) }}</td>
                <td [class.color-red]="t.BOOK_SOURCE_AMT < 0">{{ formatNumber(t.BOOK_SOURCE_AMT) }}</td>
                <td [class.color-red]="t.BOOK_AMOUNT_TO_SOURCE < 0">
                  @if (defaultTag || t.ACCT === 'Total') {
<span>{{ formatNumber(t.BOOK_AMOUNT_TO_SOURCE) }}</span>
}
                  @if (!defaultTag && t.ACCT !== 'Total') {
<input type="number"
                         [(ngModel)]="t.BOOK_AMOUNT_TO_SOURCE" [ngModelOptions]="{standalone: true}"
                         (ngModelChange)="updateRemainder(t, 'book')">
}
                </td>
                <td [class.color-red]="t.BOOK_REMAINDER < 0" class="border-right">{{ formatNumber(t.BOOK_REMAINDER) }}</td>
                <td class="nowrap">{{ t.ACCT_DESC }}</td>
              </tr>
}
              @if (TotalData.length > 0) {
<tr class="total-row">
                <td></td>
                <td class="border-right bold">{{ TotalData[0].ACCT }}</td>
                <td [class.color-red]="TotalData[0].BOOK_TOTAL_AMT < 0">{{ formatNumber(TotalData[0].BOOK_TOTAL_AMT) }}</td>
                <td [class.color-red]="TotalData[0].BOOK_SOURCE_AMT < 0">{{ formatNumber(TotalData[0].BOOK_SOURCE_AMT) }}</td>
                <td [class.color-red]="TotalData[0].BOOK_AMOUNT_TO_SOURCE < 0">{{ formatNumber(TotalData[0].BOOK_AMOUNT_TO_SOURCE) }}</td>
                <td [class.color-red]="TotalData[0].BOOK_REMAINDER < 0" class="border-right">{{ formatNumber(TotalData[0].BOOK_REMAINDER) }}</td>
                <td></td>
              </tr>
}
            </tbody>
          </table>
        </div>
}

        <!-- ──── PERCENTAGE (asset) ──── -->
        @if (selectedSourceTypeDesc === 'Percentage' && assestSourcing) {
<div class="sourcing-table-body-scroll">
          <table class="sourcing-data-table">
            <thead>
              <tr>
                <th colspan="3" class="group-header border-right">Accounts</th>
                <th colspan="6" class="group-header border-right">Tax</th>
                <th colspan="1" class="group-header">Acct</th>
              </tr>
              <tr>
                <th style="width:2%"><input type="checkbox" [(ngModel)]="checkAllButton" [ngModelOptions]="{standalone: true}" (change)="checkAll()"></th>
                <th style="width:10%">Gross Inc/Exp</th>
                <th style="width:10%" class="border-right">System Account</th>
                <th style="width:10%">Total</th><th style="width:10%">Sourced Amount</th>
                <th style="width:10%">Existing Amount to Source</th><th style="width:10%">% to Source</th>
                <th style="width:10%">New Amount to Source</th><th style="width:10%" class="border-right">Remainder</th>
                <th style="width:8%">Acct Desc</th>
              </tr>
            </thead>
            <tbody>
              @for (t of accountSourcingData; track $index) {
<tr>
                <td>@if (t.ACCT !== 'Total') {
<input type="checkbox" [(ngModel)]="t.SOURCED_CHECKBOX" [ngModelOptions]="{standalone: true}">
}</td>
                <td>{{ t.ALT_GIE_NAME }}</td>
                <td class="border-right">{{ t.SYS_ACCT }}</td>
                <td [class.color-red]="t.BOOK_TOTAL_AMT < 0">{{ formatNumber(t.BOOK_TOTAL_AMT) }}</td>
                <td [class.color-red]="t.BOOK_SOURCE_AMT < 0">{{ formatNumber(t.BOOK_SOURCE_AMT) }}</td>
                <td [class.color-red]="t.BOOK_AMOUNT_TO_SOURCE < 0">{{ formatNumber(t.BOOK_AMOUNT_TO_SOURCE) }}</td>
                <td>
                  @if (defaultTag || t.ACCT === 'Total') {
<span>{{ t.BOOK_PERCENT }}</span>
}
                  @if (!defaultTag && t.ACCT !== 'Total') {
<input type="text" style="width:50px"
                         [(ngModel)]="t.BOOK_PERCENT" [ngModelOptions]="{standalone: true}"
                         (ngModelChange)="updatePercentRemainder(t, 'book')">
}
                </td>
                <td [class.color-red]="t.NEW_BOOK_AMOUNT_TO_SOURCE < 0">{{ formatNumber(t.NEW_BOOK_AMOUNT_TO_SOURCE) }}</td>
                <td [class.color-red]="t.BOOK_REMAINDER < 0" class="border-right">{{ formatNumber(t.BOOK_REMAINDER) }}</td>
                <td class="nowrap">{{ t.ACCT_DESC }}</td>
              </tr>
}
            </tbody>
          </table>
        </div>
}
      </div>
}
    
}

    <!-- ═══════════════ EXAM / QAR SECTION ═══════════════ -->
    @if (scenarioDesc === 'EXAM') {

      @if (loadingDataQar) {
<div class="formLoader"><i class="fa fa-spinner fa-spin"></i></div>
}
      @if (!loadingDataQar) {
<div>
        <div class="row" style="margin-bottom: 10px;">
          <div class="col-md-5">
            <div class="qar-radio">
              <label><input type="radio" [(ngModel)]="qarRadioButton" name="qarOpt" value="By RAF" (change)="getCodeMastData()"> By RAF</label>
              <label><input type="radio" [(ngModel)]="qarRadioButton" name="qarOpt" value="By Custom" (change)="getCodeMastData()"> By Custom</label>
            </div>
          </div>
          <div class="col-md-7">
            <b>Default Tag Amount: {{ defaultTagAmount }}</b><br>
            <b>Taxable Income: {{ tiCCGieKey }}</b>
          </div>
        </div>

        <!-- ─── QAR By RAF (GI type) ─── -->
        @if (qarRadioButton === 'By RAF' && gieType === 'GI') {
<div class="sourcing-table-wrap">
          <div class="sourcing-table-body-scroll">
          <table class="sourcing-data-table" style="margin-left: 50px;">
            <thead>
              <tr>
                <th colspan="1" class="group-header border-right border-left"></th>
                <th colspan="4" class="group-header border-right">Tag Details</th>
                <th colspan="3" class="group-header border-right">QAR</th>
              </tr>
              <tr>
                <th style="width:5%" class="border-right border-left">Exclude</th>
                <th style="width:10%">Tag Type</th><th style="width:10%">Basket</th>
                <th style="width:10%">FDII</th><th style="width:15%" class="border-right">RAF</th>
                <th style="width:15%" class="border-right">Amount</th>
                <th style="width:15%">Percentage</th><th style="width:15%" class="border-right">Amount(%)</th>
              </tr>
            </thead>
            <tbody>
              @for (t of RafDataList; track $index) {
<tr>
                <td class="border-right border-left">
                  <input type="checkbox" [ngModel]="t.CHECKBOX === 1" [ngModelOptions]="{standalone: true}"
                         (ngModelChange)="t.CHECKBOX = $event ? 1 : 0; updateTotalApprAmount(t)">
                </td>
                <td>{{ t.SOURCE_FLAG }}</td><td>{{ t.BASKET }}</td><td>{{ t.FDII }}</td>
                <td class="border-right">{{ formatNumber(t.RAF_AMOUNT) }}</td>
                <td class="border-right"></td><td></td><td class="border-right"></td>
              </tr>
}
              <tr>
                <td class="border-right border-left"></td><td>Total</td><td></td><td></td>
                <td class="border-right">{{ formatNumber(totalAmount) }}</td>
                <td class="border-right"></td><td></td><td class="border-right"></td>
              </tr>
              <tr>
                <td class="border-right border-left"></td><td>Total Base for Apportionment</td><td></td><td></td>
                <td class="border-right">{{ formatNumber(totalApprAmount) }}</td>
                <td class="border-right">
                  <input type="number" class="form-control" [(ngModel)]="apprAmount" [ngModelOptions]="{standalone: true}"
                         (ngModelChange)="updateRafAmounts()" [disabled]="rafAmountFlagDisable === 'Y'">
                </td>
                <td>
                  <input type="number" class="form-control" [(ngModel)]="apprPercentage" [ngModelOptions]="{standalone: true}"
                         min="0" max="1" step="0.01" (ngModelChange)="updateRafPercentage()" [disabled]="rafAmountFlagDisable === 'N'">
                </td>
                <td class="border-right">
                  <input type="number" class="form-control" [ngModel]="apprPercentageAmount" [ngModelOptions]="{standalone: true}" disabled>
                </td>
              </tr>
            </tbody>
          </table>
          </div>
        </div>
}

        <!-- ─── QAR By RAF (EXP type) ─── -->
        @if (qarRadioButton === 'By RAF' && gieType !== 'GI') {
<div class="sourcing-table-wrap">
          <div class="sourcing-table-body-scroll">
          <table class="sourcing-data-table sourcing-data-table--qar-wide" style="margin-left: 50px;">
            <thead>
              <tr>
                <th colspan="1" class="group-header border-right border-left"></th>
                <th colspan="2" class="group-header border-right">Tag Details</th>
                <th colspan="7" class="group-header border-right">Basket Details</th>
                <th colspan="8" class="group-header border-right">FDII Details</th>
                <th colspan="1" class="group-header border-right">RAF</th>
                <th colspan="3" class="group-header border-right">QAR</th>
              </tr>
              <tr>
                <th class="border-right border-left" style="width:1%">Exclude</th>
                <th style="width:5%">Tag Type</th><th style="width:5%" class="border-right">Method</th>
                <th style="width:5%">U.S.</th><th style="width:5%">General Limitation</th>
                <th style="width:5%">Passive</th><th style="width:5%">Treaty</th>
                <th style="width:5%">GILTI</th><th style="width:3%">Foreign Branch</th>
                <th style="width:2%" class="border-right">Exempt</th>
                <th style="width:4%">FGN Derived DEI</th><th style="width:4%">US Derived DEI</th>
                <th style="width:3%">Sub F</th><th style="width:3%">GILTI</th>
                <th style="width:3%">FinSvcs</th><th style="width:3%">Dom Oil &amp; Gas</th>
                <th style="width:3%">Branch</th><th style="width:3%" class="border-right">CFC Dividends</th>
                <th style="width:7%" class="border-right">Amount</th>
                <th style="width:8%">Amount</th><th style="width:6%">Percentage</th>
                <th style="width:8%" class="border-right">Amount(%)</th>
              </tr>
            </thead>
            <tbody>
              @for (t of RafDataList; track $index) {
<tr>
                <td class="border-right border-left">
                  <input type="checkbox" [ngModel]="t.CHECKBOX === 1" [ngModelOptions]="{standalone: true}"
                         (ngModelChange)="t.CHECKBOX = $event ? 1 : 0; updateTotalApprAmount(t)">
                </td>
                <td>{{ t.SOURCE_FLAG }}</td><td class="border-right">{{ t.METHOD }}</td>
                <td>{{ t.US_RATIO }}</td><td>{{ t.GENERAL_LIMITATION_RATIO }}</td>
                <td>{{ t.PASSIVE_RATIO }}</td><td>{{ t.TREATY_RATIO }}</td>
                <td>{{ t.GILTI_BASKET_RATIO }}</td><td>{{ t.BRANCH_BASKET_RATIO }}</td>
                <td class="border-right">{{ t.EXEMPT_RATIO }}</td>
                <td>{{ t.FGN_DERIVED_DEI_RATIO }}</td><td>{{ t.US_DERIVED_DEI_RATIO }}</td>
                <td>{{ t.SUB_F_RATIO }}</td><td>{{ t.GILTI_FDII_RATIO }}</td>
                <td>{{ t.FINSVCS_RATIO }}</td><td>{{ t.DOM_OIL_GAS_RATIO }}</td>
                <td>{{ t.BRANCH_FDII_RATIO }}</td><td class="border-right">{{ t.CFC_DIVIDENDS_RATIO }}</td>
                <td class="border-right">{{ t.RAF_AMOUNT }}</td>
                <td><input type="number" class="form-control" [(ngModel)]="t.QAR_AMOUNT" [ngModelOptions]="{standalone: true}"
                           [disabled]="rafAmountFlagDisable === 'Y' || t.CHECKBOX === 1" (ngModelChange)="updateRafExpAmount(t)"></td>
                <td><input type="number" class="form-control" [(ngModel)]="t.QAR_PERCENTAGE" [ngModelOptions]="{standalone: true}"
                           min="0" max="1" step="0.01" [disabled]="rafAmountFlagDisable === 'N' || t.CHECKBOX === 1"
                           (ngModelChange)="updateRafExpPercentage(t)"></td>
                <td class="border-right"><input type="number" class="form-control" [ngModel]="t.QAR_PERCENT_AMOUNT" [ngModelOptions]="{standalone: true}" disabled></td>
              </tr>
}
            </tbody>
          </table>
          </div>
        </div>
}

        <!-- ─── QAR By Custom ─── -->
        @if (qarRadioButton === 'By Custom') {
<div class="sourcing-table-wrap">
          <div style="margin-left: 25px; margin-bottom: 10px;">
            <i class="fa fa-plus-circle color-green" style="font-size: 24px; cursor: pointer;" (click)="addRow()"></i>
          </div>
          <div class="sourcing-table-body-scroll">
          <table class="sourcing-data-table" style="margin-left: 50px;">
            <thead>
              <tr>
                <th style="text-align: center;">Basket</th>
                <th style="text-align: center;">FDII</th>
                <th style="text-align: center;">Ratio</th>
                <th style="text-align: center;">Amount</th>
              </tr>
            </thead>
            <tbody>
              @for (t of customRowList; track $index; let i = $index) {
<tr>
                @if (t.OPERATION_TYPE !== 'D') {

                  <td style="width: 25%;">
                    <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="basketCodeDataView"
  [selectType]="'single'" [title]="'Basket'" [hideTitleOnInput]="true" [inputAriaLabel]="'Basket'"
  [(ngModel)]="t.selectedBasketCodeItem"
  [ngModelOptions]="{standalone: true}"
  (onSelect)="onCustomRowBasketSelect($event, t)">
  @for (item of basketCodeDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Basket')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
                  </td>
                  <td style="width: 25%;">
                    <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="fdiiCodeDataView"
  [selectType]="'single'" [title]="'FDII'" [hideTitleOnInput]="true" [inputAriaLabel]="'FDII'"
  [(ngModel)]="t.selectedFdiiCodeItem"
  [ngModelOptions]="{standalone: true}"
  (onSelect)="onCustomRowFdiiSelect($event, t)">
  @for (item of fdiiCodeDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'FDII')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
                  </td>
                  <td style="width: 25%;">
                    <input type="number" class="form-control" [(ngModel)]="t.ratio" [ngModelOptions]="{standalone: true}"
                           (ngModelChange)="validateRatio(t)" [disabled]="t.ratioAmountFlag === 'Y'">
                  </td>
                  <td style="width: 25%;">
                    <input type="number" class="form-control" [(ngModel)]="t.amount" [ngModelOptions]="{standalone: true}"
                           (ngModelChange)="validateAmt(t)" [disabled]="t.ratioAmountFlag === 'N'">
                  </td>
                
}
              </tr>
}
              <tr>
                <td>Total</td><td></td><td></td><td>{{ totalAmount }}</td>
              </tr>
            </tbody>
          </table>
          </div>
        </div>
}
      </div>
}
    
}

  </div>
</div>
</form>

<!-- ═══════════════ PERCENTAGE POPUP (inline) ═══════════════ -->
@if (showPercentagePopup) {
<div class="percentage-popup-overlay" (click)="closePopUpWindow()">
  <div class="percentage-popup" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title"><strong>Apply Percentage</strong></h3>
      <div class="header-actions"><i class="fa fa-times" style="cursor:pointer" (click)="closePopUpWindow()"></i></div>
    </div>
    <div class="modal-body">
      @if (!assestSourcing) {
<div>
        <div class="row">
          <div class="col-md-7">
            <label style="width: 40%;">Enter the Percentage
              <input type="text" class="form-control" [(ngModel)]="newPercentage">
            </label>
            <button class="btn btn-info btn-sm" type="button" (click)="saveBookPercentage()">Apply Book</button>
            <button class="btn btn-info btn-sm" type="button" (click)="saveSchMPercentage()">Apply Sch M</button>
            <button class="btn btn-info btn-sm" type="button" (click)="saveBookSchMPercentage()">Apply Book/Sch M</button>
          </div>
        </div>
        <div class="sourcing-table-wrap" style="margin-top: 10px;">
          <div class="sourcing-table-body-scroll">
          <table class="sourcing-data-table sourcing-data-table--wide">
            <thead>
              <tr>
                <th colspan="4" class="group-header border-right">Accounts</th>
                <th colspan="5" class="group-header border-right">Book</th>
                <th colspan="5" class="group-header">Sch M</th>
              </tr>
              <tr>
                <th style="width:2%"></th>
                <th style="width:6%">Gross Inc/Exp</th><th style="width:5%">System</th>
                <th style="width:17%" class="border-right">General Ledger</th>
                <th style="width:7%">Total</th><th style="width:7%">Sourced Amount</th>
                <th style="width:7%">Sourced (%)</th><th style="width:7%">% to Source</th>
                <th style="width:7%" class="border-right">Remainder</th>
                <th style="width:7%">Total</th><th style="width:7%">Sourced Amount</th>
                <th style="width:7%">Sourced (%)</th><th style="width:7%">% to Source</th>
                <th style="width:7%">Remainder</th>
              </tr>
            </thead>
            <tbody>
              @for (t of accountSourcingData; track $index) {
<tr>
                @if (t.SOURCED_CHECKBOX) {

                  <td><i class="fa fa-times" style="cursor:pointer" (click)="removeAccountRow(t)"></i></td>
                  <td>{{ t.ALT_GIE_NAME }}</td><td>{{ t.SYS_ACCT }}</td>
                  <td class="border-right">{{ t.ACCT }}<br>{{ t.ACCT_DESC }}</td>
                  <td [class.color-red]="t.BOOK_TOTAL_AMT < 0">{{ formatNumber(t.BOOK_TOTAL_AMT) }}</td>
                  <td [class.color-red]="t.BOOK_SOURCE_AMT < 0">{{ formatNumber(t.BOOK_SOURCE_AMT) }}</td>
                  <td [class.color-red]="t.BOOK_AMOUNT_TO_SOURCE < 0">{{ t.BOOK_AMOUNT_TO_SOURCE }}</td>
                  <td [class.color-red]="t.BOOK_PERCENT < 0">{{ t.BOOK_PERCENT }}</td>
                  <td [class.color-red]="t.BOOK_REMAINDER < 0" class="border-right">{{ formatNumber(t.BOOK_REMAINDER) }}</td>
                  <td [class.color-red]="t.SCHDM_TOTAL_AMT < 0">{{ formatNumber(t.SCHDM_TOTAL_AMT) }}</td>
                  <td [class.color-red]="t.SCHDM_SOURCE_AMT < 0">{{ formatNumber(t.SCHDM_SOURCE_AMT) }}</td>
                  <td [class.color-red]="t.SCHDM_AMOUNT_TO_SOURCE < 0">{{ t.SCHDM_AMOUNT_TO_SOURCE }}</td>
                  <td [class.color-red]="t.SCHDM_PERCENT < 0">{{ t.SCHDM_PERCENT }}</td>
                  <td [class.color-red]="t.SCHDM_REMAINDER < 0">{{ formatNumber(t.SCHDM_REMAINDER) }}</td>
                
}
              </tr>
}
              @for (t of moreAccountsToShow; track $index) {
<tr>
                @if (t.SOURCED_CHECKBOX) {

                  <td><i class="fa fa-times" style="cursor:pointer" (click)="removeOptionsRow(t)"></i></td>
                  <td>{{ t.OPERATION_TYPE }} - {{ t.ALT_GIE_NAME }}</td><td>{{ t.SYS_ACCT }}</td>
                  <td class="border-right">{{ t.ACCT }}<br>{{ t.ACCT_DESC }}</td>
                  <td [class.color-red]="t.BOOK_TOTAL_AMT < 0">{{ formatNumber(t.BOOK_TOTAL_AMT) }}</td>
                  <td [class.color-red]="t.BOOK_SOURCE_AMT < 0">{{ formatNumber(t.BOOK_SOURCE_AMT) }}</td>
                  <td [class.color-red]="t.BOOK_AMOUNT_TO_SOURCE < 0">{{ t.BOOK_AMOUNT_TO_SOURCE }}</td>
                  <td [class.color-red]="t.BOOK_PERCENT < 0">{{ t.BOOK_PERCENT }}</td>
                  <td [class.color-red]="t.BOOK_REMAINDER < 0" class="border-right">{{ formatNumber(t.BOOK_REMAINDER) }}</td>
                  <td [class.color-red]="t.SCHDM_TOTAL_AMT < 0">{{ formatNumber(t.SCHDM_TOTAL_AMT) }}</td>
                  <td [class.color-red]="t.SCHDM_SOURCE_AMT < 0">{{ formatNumber(t.SCHDM_SOURCE_AMT) }}</td>
                  <td [class.color-red]="t.SCHDM_AMOUNT_TO_SOURCE < 0">{{ t.SCHDM_AMOUNT_TO_SOURCE }}</td>
                  <td [class.color-red]="t.SCHDM_PERCENT < 0">{{ t.SCHDM_PERCENT }}</td>
                  <td [class.color-red]="t.SCHDM_REMAINDER < 0">{{ formatNumber(t.SCHDM_REMAINDER) }}</td>
                
}
              </tr>
}
            </tbody>
          </table>
          </div>
        </div>
      </div>
}
      @if (assestSourcing) {
<div>
        <div class="row">
          <div class="col-md-7">
            <label style="width: 40%;">Enter the Percentage
              <input type="text" class="form-control" [(ngModel)]="newPercentage">
            </label>
            <button class="btn btn-info btn-sm" type="button" (click)="saveBookPercentage()">Apply Tax</button>
          </div>
        </div>
        <div class="sourcing-table-wrap" style="margin-top: 10px;">
          <div class="sourcing-table-body-scroll">
          <table class="sourcing-data-table">
            <thead>
              <tr>
                <th colspan="4" class="group-header border-right">Accounts</th>
                <th colspan="5" class="group-header border-right">Tax</th>
              </tr>
              <tr>
                <th style="width:2%"></th>
                <th style="width:6%">Gross Inc/Exp</th><th style="width:5%">System</th>
                <th style="width:17%" class="border-right">General Ledger</th>
                <th style="width:7%">Total</th><th style="width:7%">Sourced Amount</th>
                <th style="width:7%">Sourced (%)</th><th style="width:7%">% to Source</th>
                <th style="width:7%" class="border-right">Remainder</th>
              </tr>
            </thead>
            <tbody>
              @for (t of accountSourcingData; track $index) {
<tr>
                @if (t.SOURCED_CHECKBOX) {

                  <td><i class="fa fa-times" style="cursor:pointer" (click)="removeAccountRow(t)"></i></td>
                  <td>{{ t.ALT_GIE_NAME }}</td><td>{{ t.SYS_ACCT }}</td>
                  <td class="border-right">{{ t.ACCT }}<br>{{ t.ACCT_DESC }}</td>
                  <td>{{ formatNumber(t.BOOK_TOTAL_AMT) }}</td>
                  <td>{{ formatNumber(t.BOOK_SOURCE_AMT) }}</td>
                  <td>{{ t.BOOK_AMOUNT_TO_SOURCE }}</td>
                  <td>{{ t.BOOK_PERCENT }}</td>
                  <td class="border-right">{{ formatNumber(t.BOOK_REMAINDER) }}</td>
                
}
              </tr>
}
            </tbody>
          </table>
          </div>
        </div>
      </div>
}
    </div>
  </div>
</div>
}

<!-- ═══════════════ FOOTER ═══════════════ -->
<!-- Non-EXAM footer -->
@if (scenarioDesc !== 'EXAM' && (!defaultTag || enableSaveButton)) {
<div class="modal-footer" [hidden]="minimise">
  <button class="btn btn-info btn-sm" type="button" (click)="save()" [disabled]="isSaveClicked">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
</div>
}
<!-- EXAM footer -->
@if (scenarioDesc === 'EXAM') {
<div class="modal-footer" [hidden]="minimise">
  @if (qarRadioButton === 'By RAF') {
<button class="btn btn-info btn-sm" type="button"
          (click)="saveQARByRaf()" [disabled]="isSaveClicked">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
}
  @if (qarRadioButton === 'By Custom') {
<button class="btn btn-info btn-sm" type="button"
          (click)="saveQARCustom()" [disabled]="isSaveClicked">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
}
  <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
</div>
}
